import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  topologyList: [],
  account:null,
  topology: null,
  error: false,
  loading: false,
  loaded:false,
  realTopology:null,
  days:1,
  maxDays:1
};
const resetTopologyState = (state, action) => {
  return updateObject(state, initialState)
}
const initTopologyStart = (state, action) => {
  // console.log('action days', action.days, 'state days', state.days)
  return updateObject(state, {
    error: null,
    loading: true,
    loaded:false,
    days:action.days,
    maxDays:action.days>state.days?action.days:state.days
  });
};

const setTopology = (state, action) => {
  return updateObject(state, {
    realTopology: action.realTopology,
    loading: false,
    loaded: true,
    added: false,
    edited: false
  });
};

const fetchTopologyFailed = (state, action) => {
  return updateObject(state, {
    loaded: true,
    loading: false,
    error: true
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_TOPOLOGY_START:
      return initTopologyStart(state, action);
    case actionTypes.SET_TOPOLOGY:
      return setTopology(state, action);
    case actionTypes.FETCH_TOPOLOGY_FAILED:
      return fetchTopologyFailed(state, action);
    default:
      return state;
  }
};

export default reducer;
